/**
 *
 * SpotShipmentPage
 *
 */

import React from "react";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";
import {
  Tracking,
  RtlSupport,
  CanaryVersions,
  CountrySettings,
} from "root/libs/ui-containers/src";
import {
  selectAbTestRunning,
  selectAbTestVersion,
} from "root/libs/ui-containers/src/lib/AbTest";
import { parseShareCode } from "root/libs/core-libs/src";
import SpotShipment from "one-time-shipment/src/pages/SpotShipment";
import { COMMON } from "root/libs/constants/src";
import { changeSegment, prefillSegment } from "./actions";
import {
  resetItem,
  prefillShipmentLaneFromUrl,
  changeCategory,
} from "../ShipmentLane/actions";
import {
  prefillTradeLaneFromUrl,
  resetDocumentOptionsValue,
} from "../TradeLane/actions";
import {
  localShipmentDetected,
  getOffersRequestSent,
} from "../GetQuote/actions";
import { decodeTradeLaneToState } from "../TradeLane/selectors";
import { showOffersLane } from "../OffersLane/actions";

const {
  actions: { trackEvent },
} = Tracking;

const {
  selectors: { selectCanaryVersionEnabled, selectCanaryVersion },
} = CanaryVersions;
const {
  selectors: { selectRtlSupportEnabled },
} = RtlSupport;

const { withCountry } = CountrySettings;

const SpotShipmentComponent = withCountry(SpotShipment);

function SpotShipmentPage(props) {
  return (
    <SpotShipmentComponent
      iNeedTheseProps={[
        "hideSegments",
        "defaultSelectedSegment",
        "segments",
        "unitSystem",
      ]}
      {...props}
    />
  );
}

const mapStateToProps = (state) => ({
  language: state.localization.language,
  country: state.localization.country,
  storeInitialSetAction: state.personalization.storeInitialSetAction,
  wannaRunClientStorageAction:
    state.personalization.wannaRunClientStorageAction,
  analyticsUserId: state.personalization.analyticsUserId,
  isByPassBlockVisible:
    state.offersLane.isOffersLaneVisible ||
    !isEmpty(state.getQuote.networkError),
  selectedSegment: state.spotShipmentPage.selectedSegment,
  showShipmentDetectedModal: state.getQuote.localShipmentDetected,
  abTestRunning: selectAbTestRunning(state),
  abTestVersion: selectAbTestVersion(state),
  rtlSupportEnabled: selectRtlSupportEnabled(state),
  canaryEnabled: selectCanaryVersionEnabled(state),
  canaryVersion: selectCanaryVersion(state),
  isShipmentLaneVisibile: state.shipmentLane.isVisible,
  selectedUnitSystem: state.shipmentLane.selectedUnitSystem,
  isOffersLaneVisible: state.offersLane.isOffersLaneVisible,
  originFields: state.tradeLane.origin,
  destinationFields: state.tradeLane.destination,
  productItems: state.shipmentLane.initialSet.items,
});

const mapDispatchToProps = (dispatch) => ({
  onSegmentChange: (segment) => {
    dispatch(changeSegment({ segment }));
    dispatch(resetItem({ segment }));
    dispatch(changeCategory(null));
    dispatch(resetDocumentOptionsValue());
  },
  trackEvent: (trackingData) => dispatch(trackEvent(trackingData)),
  closeShipmentDetectedModal: ({ localStorageSavedShipment, country }) => {
    dispatch(localShipmentDetected({ value: false }));
    if (localStorageSavedShipment) {
      let shipmentData;
      if (localStorageSavedShipment[0] === ".") {
        shipmentData = parseShareCode(
          decodeURIComponent(localStorageSavedShipment.substring(1))
        );
      } else {
        const decodedBase64 = atob(localStorageSavedShipment);
        const decodedUri = decodeURIComponent(decodedBase64);
        shipmentData = JSON.parse(decodedUri);
      }
      const { shipmentLane, tradeLane } = shipmentData;

      dispatch(
        prefillSegment({
          segment: { id: shipmentData.spotShipmentPage.selectedSegment },
        })
      );
      dispatch(prefillTradeLaneFromUrl(decodeTradeLaneToState(tradeLane)));
      dispatch(prefillShipmentLaneFromUrl({ shipmentLane }));
      dispatch(showOffersLane());
      dispatch(getOffersRequestSent());
    }
    window.localStorage.removeItem(
      `${COMMON.SAVE_SHIPMENT_LOCAL_STORAGE}:${country}`
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SpotShipmentPage);
